import { Keuzehulp } from '../keuzehulpen'

const keelamandelenKinderen: Keuzehulp = {
  title: 'Keuzehulp Wel of niet weghalen van de keel-amandelen bij keel-ontstekingen (kinderen)',
  basePath: '/keelamandelen-kinderen',
  documentTitle: 'Keelamandelen (kinderen)',
  routes: [
    {
      path: '',
      routeId: 'P10-001',
      nextRouteId: 'P10-002',
      type: 'intro',
      title: 'Voordat u begint…',
      backButton:
        'https://www.thuisarts.nl/keuzehulp/wel-of-niet-weghalen-van-keel-amandelen-bij-keel-ontstekingen-kinderen',
      columns: [
        {
          title: 'Neem de tijd',
          description: 'Neem alle tijd die u nodig heeft om de keuzehulp in te vullen',
        },
        {
          title: '10 tot 15 minuten',
          description: 'Zo lang doen de meeste mensen over deze keuzehulp',
        },
        {
          title: 'Zoek een rustige plek',
          description: 'Zodat u goed uw aandacht erbij kunt houden',
        },
        {
          title: 'Bekijk uw adviezen',
          description: 'Download of print uw adviezen aan het einde',
        },
      ],
    },
    {
      path: '/stap-1',
      routeIndex: '1',
      routeId: 'P10-002',
      nextRouteId: 'P10-003',
      type: 'chapter',
      title: 'Uw kind heeft vaak en veel last van een keelontsteking',
      subtitle: 'Stap 1',
      description: `
        <p style="margin-bottom:0;">Op de volgende pagina leggen we uit:</p>
        <ul style="margin-top:0;">
          <li>wat zijn keel-amandelen</li>
          <li>wat is een keel-ontsteking</li>
          <li>welke klachten uw kind daarbij kan hebben</li>
        </ul>`,
      image: {
        src: `${process.env.PUBLIC_URL}/img/kk-stap-1.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-1/de-klachten-van-uw-kind',
      routeId: 'P10-003',
      nextRouteId: 'P10-004',
      type: 'explanation',
      title: 'De klachten van uw kind',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Wat zijn keel-amandelen?</h2>
          <p style="margin-top: 0">De keel-amandelen zijn 2 bobbels links en rechts achterin de keel.</br>
            Ze helpen om virussen en bacteriën te bestrijden.
          </p>

          <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Wat is een keel-ontsteking?</h2>
          <p style="margin-top: 0;">Om virussen en bacteriën te bestrijden, moeten de keel-amandelen hard werken.</br>
            Als de keel-amandelen hard werken, worden ze groter (plaatje). Dit is normaal.</br>
            Niet alleen de keel-amandelen, maar ook de rest van de keel kan ontstoken raken. Daarom kunnen kinderen zonder keel-amandelen nog steeds keel-ontstekingen krijgen.
          </p>

          <div class="img-wrapper mb-2">
            <img src="${process.env.PUBLIC_URL}/img/keelamandelen.png" alt="keelamandelen" />
          </div>

          <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Wat merkt u bij een keel-ontsteking?</h2>
          <p style="margin-top: 0;">Uw kind klaagt over keelpijn en slikken en praten gaan moeilijk. Hele jonge kinderen kunnen dit niet goed aangeven.</br>
            Sommige kinderen zijn erg ziek van de ontsteking.</br>
            Ze hebben veel pijn, lang koorts en slapen slecht. Ook eten en drinken gaan moeilijk.
          </p>

          <p>De klieren in de hals kunnen ook dik worden en pijn doen. Kinderen kunnen ook uit hun mond stinken.</br>
          Dit kan ook gevolgen hebben voor u. Sommige ouders hebben bijvoorbeeld slaapgebrek en zijn bezorgd over hun kind of moeten thuisblijven van werk als het kind ziek is.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-1/wat-zijn-de-mogelijkheden',
      routeId: 'P10-004',
      nextRouteId: 'P10-005',
      type: 'explanation',
      title: 'Wat zijn de mogelijkheden?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p style="margin-bottom:0;">Bij kinderen jonger dan 16 die vaak en veel last hebben van ontstoken keel-amandelen kunt u kiezen voor:</p>
          <ul>
            <li>afwachten</li>
            <li>een operatie om de keel-amandelen weg te halen</li>
          </ul>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-2',
      routeIndex: '2',
      routeId: 'P10-005',
      nextRouteId: 'P10-006',
      type: 'chapter',
      title: 'Afwachten',
      subtitle: 'Stap 2',
      description: `
        <p>Dit betekent dat u afwacht tot uw kind vanzelf minder keelontstekingen krijgt door het ouder worden.</p>`,
      image: {
        src: `${process.env.PUBLIC_URL}/img/kk-stap-2.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-2/afwachten',
      routeId: 'P10-006',
      nextRouteId: 'P10-007',
      type: 'explanation',
      title: 'Afwachten',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Klachten door ontstoken keel-amandelen passen bij de leeftijd van jonge kinderen. Zij krijgen veel virussen en bacteriën voor het eerst in hun lichaam. Hierdoor maakt het lichaam een goede verdediging (afweer) tegen virussen en bacteriën.</br>
          Na het 7e jaar hebben kinderen daardoor minder vaak ontstoken keel-amandelen.</p>

          <p style="margin-bottom: 2.5rem;">Als u kiest voor afwachten en uw kind krijgt weer een keel-ontsteking, kunt u opnieuw de mogelijkheden met uw arts bespreken.</p>

          <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Hoe goed helpt afwachten?</h2>
          <p style="margin-top: 0;">Door niet te opereren wacht u tot de keel-ontstekingen vanzelf minder worden, doordat uw kind weerstand ontwikkelt en eroverheen groeit.</br>
            Als u kiest voor afwachten, krijgt uw kind waarschijnlijk vaker een keelontsteking dan na een operatie.
          </p>

          <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Risico’s van afwachten</h2>
          <p style="margin-top: 0;">Afwachten heeft meestal geen risico’s.</br>
            Heel soms wordt de keel-ontsteking ernstig. Dan kan het nodig zijn dat uw kind een operatie nodig heeft of moet worden opgenomen in het ziekenhuis.
          </p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-2/voor-en-nadelen-van-afwachten',
      routeId: 'P10-007',
      nextRouteId: 'P10-008',
      type: 'explanation',
      title: 'Voor- en nadelen van afwachten',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Voordelen van afwachten</h2>
          <ul>
            <li>U en uw kind hebben geen ongemakken en bijwerkingen van de operatie en narcose.</li>
            <li>U en uw kind hebben geen risico van de operatie.</li>
            <li>U kunt later toch nog kiezen voor een operatie.</li>
            <li>Uw kind hoeft meestal niet naar het ziekenhuis.</li>
          </ul>
          <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Nadelen van afwachten</h2>
          <ul>
            <li>Uw kind krijgt waarschijnlijk vaker een keel-ontsteking dan na een operatie.</li>
            <li>Ook kunnen de keel-ontstekingen ernstiger zijn.</li>
          </ul>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3',
      routeIndex: '3',
      routeId: 'P10-008',
      nextRouteId: 'P10-009',
      type: 'chapter',
      title: 'Operatie',
      subtitle: 'Stap 3',
      description: `
          <p>Bij deze operatie haalt de KNO-arts de keel-amandelen weg via de mond van uw kind.</p>`,
      image: {
        src: `${process.env.PUBLIC_URL}/img/kk-stap-3.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-3/operatie-om-de-keelamandelen-weg-te-halen',
      routeId: 'P10-009',
      nextRouteId: 'P10-010',
      type: 'explanation',
      title: 'Operatie om de keel-amandelen weg te halen',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Uw kind wordt geopereerd op een moment dat het niet erg ziek is van de ontstoken keel-amandelen.</p>

          <p>Voor de operatie wordt uw kind in slaap gebracht.</br>
          Dit noemen we ook wel narcose.</br>
          Daardoor heeft uw kind geen pijn tijdens de operatie.</br>
          De verdovingsarts (anesthesioloog) of verpleegkundige vertelt u hier van te voren meer over. Bespreek het met de arts als u hierover zorgen heeft.</p>

          <p>Tijdens een operatie haalt de kno-arts de keel-amandelen weg via de mond van uw kind.</br>
          Bij jonge kinderen haalt de kno-arts vaak ook de neus-amandel weg. Daardoor kan het kind weer beter door de neus ademen.</br>
          De operatie duurt ongeveer 10 tot 30 minuten.</p>

          <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Na de operatie</h2>
          <p style="margin-top: 0;">Uw kind kan vaak dezelfde dag naar huis.</br>
          Na de operatie heeft uw kind veel pijn in de keel en moeite met slikken. Ook kan uw kind pijn in de oren voelen.</br>
          Ook kan er meteen na de operatie wat bloed uit de keel komen.</br>
          En uw kind kan tijdelijk een andere stem hebben en de smaak kan tijdelijk anders zijn.</p>

          <p>De keel kan 5 tot 7 dagen pijn doen. De pijn is vergelijkbaar met de klachten van een keel-ontsteking.</br>
          Daarom krijgt uw kind pijnstillers. Ook koude dranken en waterijsjes helpen tegen de pijn. Door de keelpijn kan uw kind problemen hebben met eten en drinken. Soms gaat dit zo moeilijk dat uw kind in het ziekenhuis moet blijven.</p>

          <p>Er is een kans dat uw kind andere klachten krijgt door de operatie en/of de narcose.</br>
          Bijvoorbeeld: misselijkheid, overgeven of koorts.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/hoe-goed-helpt-een-operatie',
      routeId: 'P10-010',
      nextRouteId: 'P10-011',
      type: 'explanation',
      title: 'Hoe goed helpt een operatie?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Na de operatie hebben kinderen minder keel-ontstekingen. Maar uw kind kan ook ná een operatie nog keel-ontstekingen krijgen. Dit komt dan door een ontsteking van de rest van de keel.</p>
          <p>Hoe meer ontstekingen uw kind voor de operatie had, hoe meer voordeel u van de operatie kunt verwachten. Hierdoor blijft uw kind waarschijnlijk minder vaak ziek thuis.</p>
          <p>Alle kinderen krijgen minder keel-ontstekingen als ze ouder worden. Dit geldt zowel voor kinderen die aan hun keel-amandelen geopereerd zijn als voor kinderen die niet  aan hun keel-amandelen geopereerd zijn.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/risicos-van-de-operatie',
      routeId: 'P10-011',
      nextRouteId: 'P10-012',
      type: 'explanation',
      title: 'Risico’s van een operatie',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <ul>
            <li>Er is een kans dat de wond in de keel plotseling gaat bloeden. Dit noemen we een nabloeding. Een nabloeding komt voor bij ongeveer 1 tot 2 van de 100 kinderen na een operatie, meestal binnen 12 uur na de operatie. Maar het kan tot 2 weken na de operatie nog gebeuren. Uw kind spuugt hierdoor opeens helder rood bloed uit. Een nabloeding kan heel gevaarlijk zijn voor uw kind. Meestal wordt uw kind dan opnieuw in het ziekenhuis opgenomen en soms moet uw kind opnieuw geopereerd worden om de bloeding te stoppen.</li>
            <li>Sommige kinderen moeten weer in het ziekenhuis worden opgenomen omdat ze door pijn of misselijkheid niet goed kunnen drinken.</li>
            <li>De smaak en stem kunnen veranderen. Dit is meestal tijdelijk.</li>
            <li>In Nederland is onderzoek gedaan naar de kans dat een kind overlijdt door een nabloeding. Dit gebeurt bijna nooit.</li>
          </ul>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-4',
      routeIndex: '4',
      routeId: 'P10-012',
      nextRouteId: 'P10-013',
      type: 'chapter',
      title: 'Vergelijk de mogelijkheden',
      subtitle: 'Stap 4',
      description: `
        <p>We zetten alle verschillen voor u op een rijtje. Wat is voor u belangrijk?</p>`,
      image: {
        src: `${process.env.PUBLIC_URL}/img/kk-stap-4.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-4/verschillen-op-een-rijtje',
      routeId: 'P10-013',
      nextRouteId: 'P10-014',
      type: 'explanation',
      title: 'Verschillen op een rijtje',
      titleAlign: 'center',
      description: `
        <table>
          <thead>
            <tr>
              <th></th>
              <th>Afwachten</th>
              <th>Operatie: keel-amandelen weghalen</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Wat betekent het?</th>
              <td>Wachten tot uw kind vanzelf minder ontstekingen krijgt doordat het weerstand ontwikkelt bij het ouder worden.</td>
              <td>Een operatie waarbij uw kind narcose krijgt.</br></br>De kno-arts haalt de keel-amandelen weg via de mond.</td>
            </tr>
            <tr>
              <th>Hoe goed helpt het?</th>
              <td>Zonder operatie hebben kinderen waarschijnlijk meer keel-ontstekingen.</td>
              <td>Kinderen hebben na de operatie waarschijnlijk minder keelontstekingen.</br>
              Uw kind blijft minder vaak ziek thuis.</br></br>
              Uw kind heeft minder vaak keelpijn door ontstoken keel-amandelen, maar wel  keelpijn door de operatie.</br></br>
              Kans dat de stem tijdelijk anders wordt.</br></br>
              Na een operatie kunnen kinderen nog steeds keel-ontstekingen krijgen.</td>
            </tr>
            <tr>
              <th>Risico's</th>
              <td>Heel soms een operatie of opname in het ziekenhuis.</td>
              <td>Er is een kans dat de wond plotseling gaat bloeden (1 tot 2 van de 100 kinderen).</br></br>
              Kinderen gaan bijna nooit dood door deze nabloeding.</td>
            </tr>
            <tr>
              <th>Voordelen</th>
              <td>Geen ongemakken van de operatie en de narcose.</br></br>
              Geen risico  op een nabloeding.</br></br>
              U kunt later toch nog kiezen voor een operatie.</br></br>
              Uw kind hoeft meestal niet naar het ziekenhuis.
              </td>
              <td>
              Minder vaak keel-ontstekingen.</br>
              Vooral bij kinderen met veel keel-ontstekingen kan een operatie aan de keel-amandelen goed helpen.</br></br>
              Uw kind blijft minder vaak ziek thuis.
              </td>
            </tr>
            <tr>
              <th>Nadelen</th>
              <td>Vaker keel-ontstekingen en keelpijn.</br></br>
              De keel-ontstekingen kunnen ernstiger zijn.</br></br>
              Uw kind blijft waarschijnlijk vaker ziek thuis.
              </td>
              <td>
              Nog steeds kans op keel-ontstekingen.</br></br>
              Ongemakken van een operatie, keelpijn na de operatie.</br></br>
              Kans op klachten door de narcose.</br></br>
              Kans op een nabloeding.</br></br>
              Kans dat de smaak en stem tijdelijk anders worden.
              </td>
            </tr>
          </tbody>
        </table>
      `,
      align: 'left',
      button: 'Ga verder',
    },
    {
      path: '/stap-4/belangrijke-punten',
      routeId: 'P10-014',
      nextRouteId: 'P10-015',
      type: 'explanation',
      title: 'Belangrijke punten',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Hieronder staan vragen. Ze gaan over de informatie in de keuzehulp.</br>
            Weet u het antwoord op de vragen niet? Lees dan de informatie opnieuw of praat met uw arts.</br>
            U kunt de vragen ook overslaan. Klik dan op 'Ga verder'.
          </p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-4/vraag-1',
      routeId: 'P10-015',
      nextRouteId: 'P10-016',
      title: 'Krijgt mijn kind vanzelf minder keel-ontstekingen als het ouder wordt?',
      subtitle: 'Vraag',
      type: 'feedbackQuestion',
      feedbackAnswers: [
        {
          title: 'Ja',
          feedback: `
            <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Dat klopt.</h2><p style="margin-top: 0;">Als uw kind ouder wordt, worden de keel-ontstekingen meestal vanzelf minder.</p>
            <p>Kinderen jonger dan 7 jaar hebben vaak keel-ontstekingen. Na het 7e jaar wordt dat minder. Dit geldt zowel voor kinderen die geopereerd zijn als voor kinderen die geen operatie krijgen.</p>`,
          correctOption: true,
        },
        {
          title: 'Nee',
          feedback: `<h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Dat klopt niet.</h2> <p style="margin-top: 0;">Als uw kind ouder wordt, worden de ontstekingen meestal vanzelf minder.</p>
            <p>Kinderen jonger dan 7 jaar hebben vaak keel-ontstekingen. Na het 7e jaar wordt dat minder. Dit geldt zowel voor kinderen die geopereerd zijn als voor kinderen die geen operatie krijgen.</p>`,
          correctOption: false,
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-4/vraag-2',
      routeId: 'P10-016',
      nextRouteId: 'P10-017',
      title:
        'Een operatie heeft een groot effect op het aantal keel-ontstekingen als mijn kind weinig klachten van keel-ontstekingen heeft.',
      subtitle: 'Vraag',
      type: 'feedbackQuestion',
      feedbackAnswers: [
        {
          title: 'Ja',
          feedback: `<h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Dat klopt niet.</h2><p style="margin-top: 0;">Als uw kind weinig klachten van keel-ontstekingen heeft, zal een operatie aan de keel-amandelen weinig helpen. Bij weinig klachten adviseren artsen daarom meestal om af te wachten en geen operatie te laten doen.</p>`,
          correctOption: false,
        },
        {
          title: 'Nee',
          feedback: `<h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Dat klopt.</h2><p style="margin-top: 0;"> Als uw kind weinig klachten van keel-ontstekingen heeft, zal een operatie aan de keel-amandelen weinig helpen. Bij weinig klachten adviseren artsen daarom meestal om af te wachten en geen operatie te laten doen.</p>`,
          correctOption: true,
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-4/vraag-3',
      routeId: 'P10-017',
      nextRouteId: 'P10-018',
      title: 'Heeft een operatie zin als mijn kind veel last van keel-ontstekingen heeft?',
      subtitle: 'Vraag',
      type: 'feedbackQuestion',
      feedbackAnswers: [
        {
          title: 'Ja',
          feedback: `<h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Dat klopt.</h2><p style="margin-top: 0;">Vooral bij kinderen met veel keel-ontstekingen kan een operatie aan de keel-amandelen goed helpen. Wel kunnen kinderen ook na een operatie nog keel-ontstekingen krijgen.</p>`,
          correctOption: true,
        },
        {
          title: 'Nee',
          feedback: `<h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Dat klopt niet.</h2><p style="margin-top: 0;"> Vooral bij kinderen met veel keel-ontstekingen kan een operatie aan de keel-amandelen goed helpen. Wel kunnen kinderen ook na een operatie nog keel-ontstekingen krijgen.</p>`,
          correctOption: false,
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-4/vraag-4',
      routeId: 'P10-018',
      nextRouteId: 'P10-019',
      title:
        'Kan mijn kind nog een keelontsteking krijgen na een operatie om de keel-amandelen weg te halen? ',
      subtitle: 'Vraag',
      type: 'feedbackQuestion',
      feedbackAnswers: [
        {
          title: 'Ja',
          feedback: `<h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Dat klopt.</h2><p style="margin-top: 0;"> Niet alleen de keel-amandelen, maar ook de rest van de keel kan ontstoken raken. Daarom kunnen kinderen zonder keel-amandelen nog steeds keel-ontstekingen krijgen. Kinderen met veel keel-ontstekingen krijgen na een operatie wel minder keel-ontstekingen.</p>`,
          correctOption: true,
        },
        {
          title: 'Nee',
          feedback: `<h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Dat klopt niet.</h2><p style="margin-top: 0;"> Niet alleen de keel-amandelen, maar ook de rest van de keel kan ontstoken raken. Daarom kunnen kinderen zonder keel-amandelen nog steeds keel-ontstekingen krijgen. Kinderen met veel keel-ontstekingen krijgen na een operatie wel minder keel-ontstekingen.</p>`,
          correctOption: false,
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-4/vraag-5',
      routeId: 'P10-019',
      nextRouteId: 'P10-020',
      title: 'Heeft een operatie risico’s?',
      subtitle: 'Vraag',
      type: 'feedbackQuestion',
      feedbackAnswers: [
        {
          title: 'Ja',
          feedback: `<h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Dat klopt.</h2><p style="margin-top: 0;">Tijdens en na een operatie heeft uw kind een kleine kans op bijvoorbeeld een bloeding van de wond in de keel of klachten van de narcose.</p>`,
          correctOption: true,
        },
        {
          title: 'Nee',
          feedback: `<h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Dat klopt niet.</h2><p style="margin-top: 0;">Tijdens en na een operatie heeft uw kind een kleine kans op bijvoorbeeld een bloeding van de wond in de keel of klachten van de narcose.</p>`,
          correctOption: false,
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-4/vraag-6',
      routeId: 'P10-020',
      nextRouteId: 'P10-021',
      type: 'question',
      title: 'Wat verwacht u van afwachten of een operatie? ',
      description:
        'U kunt hier invullen wat u verwacht als u kiest voor afwachten of een operatie. Bijvoorbeeld: mijn kind heeft daarna minder keelpijn. ',
      descriptionAlign: 'left',
      button: 'Ga verder',
      questions: [
        {
          placeholder: 'Ik verwacht dat...',
          type: 'textarea',
        },
      ],
    },
    {
      path: '/stap-4/wat-is-voor-u-belangrijk',
      routeId: 'P10-021',
      nextRouteId: 'P10-022',
      type: 'explanation',
      title: 'Wat is voor u belangrijk?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>U bepaalt samen met uw arts wat het beste is voor uw kind. Dit hangt af van wat u belangrijk vindt. Dit kunt u hieronder aangeven.</br>
          Is uw kind 12 jaar of ouder? Dan beslist uw kind ook mee over de behandeling.</p>

          <p><strong>Let op:</strong> er komt niet automatisch een antwoord uit. Onderaan deze pagina vult u zelf in wat u het liefste wilt. En hoe zeker u dit weet.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-4/vraag-7',
      routeId: 'P10-022',
      nextRouteId: 'P10-023',
      type: 'likertScale',
      subtitle: 'Stelling',
      title:
        'Als mijn kind een keel-ontsteking heeft, doet het de normale dingen die het altijd doet.',
      answers: [
        { title: 'Eens' },
        { title: 'Een beetje eens' },
        { title: 'Niet eens, niet oneens' },
        { title: 'Een beetje oneens' },
        { title: 'Oneens' },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-4/vraag-8',
      routeId: 'P10-023',
      nextRouteId: 'P10-024',
      type: 'likertScale',
      subtitle: 'Stelling',
      title:
        'Mijn kind kan toch nog een keel-ontsteking krijgen na een operatie; ik vind het niet de moeite waard.',
      answers: [
        { title: 'Eens' },
        { title: 'Een beetje eens' },
        { title: 'Niet eens, niet oneens' },
        { title: 'Een beetje oneens' },
        { title: 'Oneens' },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-4/vraag-9',
      routeId: 'P10-024',
      nextRouteId: 'P10-025',
      type: 'likertScale',
      subtitle: 'Stelling',
      title:
        'Ik wacht liever af tot de klachten van mijn kind vanzelf overgaan, dan dat ik mijn kind laat opereren.',
      answers: [
        { title: 'Eens' },
        { title: 'Een beetje eens' },
        { title: 'Niet eens, niet oneens' },
        { title: 'Een beetje oneens' },
        { title: 'Oneens' },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-4/vraag-10',
      routeId: 'P10-025',
      nextRouteId: 'P10-026',
      type: 'likertScale',
      subtitle: 'Stelling',
      title: 'Ik wil niet dat mijn kind een operatie onder narcose krijgt.',
      answers: [
        { title: 'Eens' },
        { title: 'Een beetje eens' },
        { title: 'Niet eens, niet oneens' },
        { title: 'Een beetje oneens' },
        { title: 'Oneens' },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-4/vraag-11',
      routeId: 'P10-026',
      nextRouteId: 'P10-027',
      type: 'likertScale',
      subtitle: 'Stelling',
      title: 'Ik wil geen ongemak van een operatie.',
      answers: [
        { title: 'Eens' },
        { title: 'Een beetje eens' },
        { title: 'Niet eens, niet oneens' },
        { title: 'Een beetje oneens' },
        { title: 'Oneens' },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-4/vraag-12',
      routeId: 'P10-027',
      nextRouteId: 'P10-028',
      type: 'likertScale',
      subtitle: 'Stelling',
      title: 'Ik maak me zorgen over de risico’s van een operatie.',
      answers: [
        { title: 'Eens' },
        { title: 'Een beetje eens' },
        { title: 'Niet eens, niet oneens' },
        { title: 'Een beetje oneens' },
        { title: 'Oneens' },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-4/wat-wilt-u',
      routeId: 'P10-028',
      nextRouteId: 'P10-029',
      type: 'explanation',
      title: 'Wat wilt u?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>U heeft nagedacht over verschillende mogelijkheden. Kies wat u zou willen.</br>
          Samen met uw arts praat u over deze keuzehulp. Samen kiest u wat het beste bij u en uw kind past.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-4/vraag-13',
      routeId: 'P10-029',
      nextRouteId: 'P10-030',
      subtitle: 'Keuze',
      title: 'Ik wil',
      type: 'uniqueQuestion',
      answers: [{ title: 'Afwachten' }, { title: 'Operatie' }],
      button: 'Ga verder',
    },
    {
      path: '/stap-4/vraag-14',
      routeId: 'P10-030',
      nextRouteId: 'P10-031',
      type: 'question',
      title: 'Waarom wilt u dit het liefst?',
      description: 'Dit kunt u hier invullen:',
      descriptionAlign: 'left',
      button: 'Ga verder',
      questions: [
        {
          placeholder: 'Omdat...',
          type: 'textarea',
        },
      ],
    },
    {
      path: '/stap-4/vraag-15',
      routeId: 'P10-031',
      nextRouteId: 'P10-032',
      type: 'likertScale',
      subtitle: 'Vraag',
      title: 'Hoe zeker bent u van wat u wilt?',
      answers: [
        { title: 'Heel zeker' },
        { title: 'Zeker' },
        { title: 'Weet ik niet' },
        { title: 'Onzeker' },
        { title: 'Heel onzeker' },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-4/afsluiting',
      routeId: 'P10-032',
      nextRouteId: 'P10-033',
      type: 'explanation',
      title: 'Afsluiting',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Beantwoord de onderstaande vragen.</br>
          Heeft u op 1 of meer vragen ‘nee’ geantwoord?</br>
          Praat daarover met uw arts.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-4/vraag-16',
      routeId: 'P10-033',
      nextRouteId: 'P10-034',
      title: 'Weet u genoeg over de voordelen en nadelen van afwachten en een operatie?',
      type: 'defaultQuestion',
    },
    {
      path: '/stap-4/vraag-17',
      routeId: 'P10-034',
      nextRouteId: 'P10-035',
      title: 'Weet u wat voor u het belangrijkste is?',
      type: 'defaultQuestion',
    },
    {
      path: '/stap-4/vraag-18',
      routeId: 'P10-035',
      nextRouteId: 'P10-036',
      title: 'Kunt u een goede beslissing nemen?',
      type: 'defaultQuestion',
    },
    {
      path: '/stap-4/vraag-19',
      routeId: 'P10-036',
      nextRouteId: 'P10-037',
      type: 'question',
      title: 'Extra vragen',
      description:
        'Heeft u nog zorgen of vragen? Of zijn er nog dingen onduidelijk? Dit kunt u hier invullen en bespreken met uw arts:',
      descriptionAlign: 'left',
      button: 'Door naar uw antwoorden',
      questions: [
        {
          placeholder: 'Ik vraag me af...',
          type: 'textarea',
        },
      ],
    },
    {
      path: '/print-overview',
      routeIndex: '5',
      routeId: 'P10-037',
      nextRouteId: 'end',
      type: 'end',
      header: {
        description: `
          <div>
            <p>U bent klaar met het invullen van de keuzehulp.</p>
            <p><strong>Let op:</strong> kiest u voor een operatie om de keel-amandelen weg te halen? Dan verwijst de huisarts u door naar de kno-arts.</br>
              De kno-arts onderzoekt of uw kind deze operatie kan krijgen.
            </p>
            <p>Kiest u voor afwachten? Dan kunt u zoals altijd bij uw huisarts terecht als uw kind ziek is.</p>
          </div>
        `,
      },
    },
  ],
}

export default keelamandelenKinderen
